/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import {Employers} from '../../core/_models'
import Avatar from 'react-avatar'
import {toAbsoluteUrl} from '../../../../../../../_metronic/helpers'

type Props = {
  employers: Employers
}

const EmployersInfoCell: FC<Props> = ({employers}) => {
  console.log("employers====",employers);
  const fullName = employers.firstName + " " + employers.lastName;
  return (
    <div className='d-flex align-items-center'>
      {/* begin:: Avatar */}
      <div className='symbol symbol-circle symbol-50px overflow-hidden me-3'>
        <a href='#'>
          {employers.linkedInProfile ? (
            <div className='symbol-label'>
              <img
                src={toAbsoluteUrl(`/media/${employers.linkedInProfile}`)}
                alt={employers.firstName}
                className='w-100'
              />
            </div>
          ) : (
            <Avatar size='40' round='20px' maxInitials={2} name={fullName}></Avatar>
          )}
        </a>
      </div>
      <div className='d-flex flex-column'>
        <a href='#' className='text-gray-800 text-hover-primary mb-1'>
          {fullName}
        </a>
        <span>{employers.emailId}</span>
      </div>
    </div>
    
  )
}

export {EmployersInfoCell}
